import type { JSX } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

import { IconButton } from '@mui/material';

import { InfoIcon } from 'icons';

type DetailsButtonProps = {
    iconClass?: (...props: any) => JSX.Element;
    route: string;
};

export function DetailsButton({
    route,
    ...other
}: Omit<React.ComponentPropsWithoutRef<typeof IconButton>, 'component'> & Omit<LinkProps, 'to'> & DetailsButtonProps) {
    return (
        <IconButton color="primary" component={Link} size="small" to={route} {...other} aria-label="Details">
            <InfoIcon />
        </IconButton>
    );
}
